export default [
  {
    path: '/transaction',
    name: 'Transaction',
    redirect: '/transaction/query',
    meta: {
      icon: 'icon-acquiring',
      resourceCode: 'transaction',
    },
  },
  {
    path: '/transaction/query',
    name: 'Transaction List',
    component: () => import('@/views/transaction/transaction-query/index.vue'),
    meta: {
      resourceCode: 'transaction:list',
      activeMenu: '/transaction',
    },
  },
  {
    path: '/transaction/details',
    name: 'Transaction Details',
    component: () => import('@/views/transaction/transaction-details/index.vue'),
    meta: {
      activeMenu: '/transaction',
      name: 'message.transaction.detail',
    },
  },
  {
    path: '/transaction/refund',
    name: 'Refund Manage',
    component: () => import('@/views/transaction/refund-manage/index.vue'),
    meta: {
      resourceCode: 'transaction:refund',
      activeMenu: '/transaction',
    },
  },
  {
    path: '/transaction/refund/details',
    name: 'Refund Details',
    component: () => import('@/views/transaction/refund-manage/details.vue'),
    meta: {
      resourceCode: 'transaction:refund:details',
      activeMenu: '/transaction',
      name: 'message.transaction.refundDetail',
    },
  },
  {
    path: 'settlement/declaration',
    name: 'Settlement Detail Management',
    component: () => import('@/views/settlement/restore-detailed-declaration/index.vue'),
    meta: {
      resourceCode: 'settlement:declaration',
      activeMenu: '/transaction',
    },
  },
  {
    path: '/transaction/refuse',
    name: 'Refuse Manage',
    component: () => import('@/views/transaction/refuse-manage/index.vue'),
    meta: {
      resourceCode: 'transaction:refuse',
    },
  },
  {
    path: '/transaction/refuse/details',
    name: 'Refuse Manage Details',
    component: () => import('@/views/transaction/refuse-manage/details.vue'),
    meta: {
      name: 'message.refuse.details',
      activeMenu: '/transaction/refuse',
    },
  },
  {
    path: '/transaction/refuse/view',
    name: 'Refuse Manage View',
    component: () => import('@/views/transaction/refuse-manage/view/index.vue'),
    meta: {
      name: 'message.refuse.appealDetails',
      activeMenu: '/transaction/refuse',
    },
  },
  {
    path: '/transaction/refuse/appeal',
    name: 'Refuse Manage Appeal',
    component: () => import('@/views/transaction/refuse-manage/view/index.vue'),
    meta: {
      name: 'message.refuse.appealDetails',
    },
  },
  {
    path: '/transaction/refuse/edit',
    name: 'Refuse Manage Appeal V2',
    component: () => import('@/views/transaction/refuse-manage/edit/index.vue'),
    meta: {
      name: 'message.refuse.appealDetails',
    },
  },
  {
    path: '/transaction/dispute',
    name: 'Dispute Manage',
    component: () => import('@/views/transaction/dispute/list/index.vue'),
    meta: {
      resourceCode: 'transaction:dispute',
      tip: 'message.dispute.titleTip',
    },
  },
  {
    path: '/transaction/dispute/detail',
    name: 'Dispute Detail',
    component: () => import('@/views/transaction/dispute/detail/index.vue'),
    meta: {
      resourceCode: 'transaction:dispute:detail',
      name: 'message.dispute.disputeDetail',
    },
  },
  {
    path: '/transaction/dividend',
    name: 'Dividend List',
    component: () => import('@/views/transaction/dividend/index.vue'),
    meta: {
      resourceCode: 'transaction:dividend',
      activeMenu: '/transaction',
    },
  },
];
